module.exports = __webpack_public_path__ + "img/about-ch1-coresectors-transportation.286cb984.svg";